import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { PaisService } from 'src/app/generales/services/pais.service';

@Component({
  selector: 'app-stats-search',
  templateUrl: './stats-search.component.html',
  styleUrls: ['./stats-search.component.scss'],
})
export class StatsSearchComponent implements OnInit {
  @Output() emitSearch = new EventEmitter();
  public filter = {
    month: (new Date()).getMonth(),
    search: ''
  }

  constructor(
    public paisSv: PaisService

  ) { }

  ngOnInit() {}

  search(ev){
    this.filter.search = ev.value;
    this.emitSearch.emit(this.filter);
  }

  setMonth(){
    this.emitSearch.emit(this.filter);
  }
}
